<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <sarala-table :model="model" ref="table">
                    <template #action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    :to="{
                                        name: $t('routes.mail.edit'),
                                        params: { id: item.id },
                                    }"
                                >
                                    <v-icon color="blue-grey" v-on="on"
                                        >mdi-pencil</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('resources.default.edit') }}</span>
                        </v-tooltip>
                    </template>
                </sarala-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import SaralaTable from '@/shared/components/SaralaTable'
import Mail from '@/models/settings/Mail'

export default {
    components: {
        SaralaTable,
    },
    computed: {
        model() {
            return new Mail()
        },
    },
}
</script>

<style></style>
